import React from "react";

import { Hero, CTASection } from "../Components/sections";
import Seo from "../Components/seo/Seo";

const team = [
  {
    name: "Samson Fiado",
    role: "CEO & Software Developer",
    bio: "Shapes the business and technical strategy at EasyBooks Solutions.",
    img: "Assets/Team/M4.jpg",
  },
  {
    name: "Anna Msukwa",
    role: "Systems Support & Client Relationship Officer",
    bio: "Manages system operations and fosters strong client relationships.",
    img: "Assets/Team/M1.jpg",
  },
  {
    name: "Elias Mgala",
    role: "Software Developer",
    bio: "Delivers robust solutions and platform improvements across products and services.",
    img: "Assets/Team/M3.jpg",
  },
  {
    name: "Wakisa Munthali",
    role: "Software Developer",
    bio: "Contributes to product development and customer-focused delivery.",
    img: "Assets/Team/M5.jpg",
  },
  {
    name: "Vincent Mazenga",
    role: "Marketing & Sales Officer",
    bio: "Supports go-to-market, growth, and customer engagement.",
    img: "Assets/Team/M6.jpg",
  }
];

function Team() {
  return (
    <div>
      <Seo
        title="Team"
        description="Meet the EasyBooks Solutions team—product, engineering, delivery, and go-to-market experts."
      />
      <Hero
        eyebrow="Team"
        title="Meet the people behind EasyBooks."
        subtitle="A cross-functional team focused on building systems that are usable, secure, and effective in the real world."
        primaryCta={{ label: "Contact us", to: "/Contact" }}
        secondaryCta={{ label: "See clients", to: "/Clients" }}
        imageSrc="Assets/Catalog/TEAM.jpg"
        imageAlt="EasyBooks team"
        highlights={["Product + engineering", "Support and delivery", "Marketing and sales"]}
      />

      <section className="eb-section bg-white">
        <div className="eb-container">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {team.map((m) => (
              <div key={m.name} className="eb-card overflow-hidden">
                <img
                  src={m.img}
                  alt={m.name}
                  className="h-100 w-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
                <div className="p-6">
                  <div className="text-lg font-semibold text-slate-900">{m.name}</div>
                  <div className="mt-1 text-sm font-semibold text-brand-800">{m.role}</div>
                  <p className="mt-3 text-sm text-slate-600">{m.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        title="Want to collaborate with the team?"
        subtitle="Reach out with your goals and timelines and we’ll set up a quick call."
        primaryCta={{ label: "Start a conversation", to: "/Contact" }}
        secondaryCta={{ label: "Explore products", to: "/EasyBooks_Accounting" }}
      />
    </div>
  );
}

export default Team;